// extracted by mini-css-extract-plugin
export var root = "_593662318a06a8201ff4c008dc462083-css";